import React from "react";
import { connect } from "react-redux";
import PrimaryDivider from './PrimaryDivider';
import Users from "./Users";
import Reports from "./Reports";
import Templates from "./Templates";
import Log from "./Log";
import { Link } from "react-router-dom";
import Fade from '@material-ui/core/Fade';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import Typography from '@material-ui/core/Typography';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import AccountBoxIcon from '@material-ui/icons/AccountBox';

const icons = {
    "users": <PersonAddIcon />,
    "log": <AccountBoxIcon />,
    "analytics": <AccountBoxIcon />,
    "templates": <AccountBoxIcon />
};

class Dashboard extends React.Component {

    state = {
        value: ["users", "log", "analytics", "templates"].indexOf(this.props.tabAction)
    };

    switchTab = (e, value) => this.setState({ value });

    render() {
        const { value } = this.state;
        const { tabAction = "transactions", userPermissions } = this.props;

        const tabs = { "users": "Персонал", "log": "Журнал", "analytics": "Аналитика", "templates": "Шаблоны" };

        return (
            <Fade in={true}>
                <React.Fragment>
                    <Typography variant="h4" >Панель управления</Typography>
                    <PrimaryDivider />
                    <Tabs value={value}
                          onChange={this.switchTab}
                          centered >
                        {Object.keys(tabs).map((tab, i) => <Tab key={i}
                                                                label={tabs[tab]}
                                                                classes={{ labelContainer: "text-centered" }}
                                                                component={Link}
                                                                icon={icons[tab]}
                                                                to={`/dashboard/${tab}`} />
                        )}
                    </Tabs>
                    <SwipeableViews axis="x" index={value} className="mt10">
                        <div dir="x">
                            {tabAction === "users" && <Users userPermissions={userPermissions} />}
                        </div>
                        <div dir="x">
                            {tabAction === "log" && <Log />}
                        </div>
                        <div dir="x">
                            {tabAction === "analytics" && <Reports userPermissions={userPermissions} />}
                        </div>
                        <div dir="x">
                            {tabAction === "templates" && <Templates />}
                        </div>
                    </SwipeableViews>
                </React.Fragment>
            </Fade>
        )
    }
}

const mapStateToProps = (state, {match}) => ({
    tabAction: match.params.tab,
    userPermissions: state.common.user.permissions,
});

export default connect(mapStateToProps, null)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard.js